var _linearGradient, _path, _g, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRocket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 80,
    viewBox: "0 0 80 80",
    width: 80,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 21.64,
    x2: 22.3,
    y1: 68.169,
    y2: 42.759
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9f8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#ff9793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#ff8aa4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#ff80b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#ff66d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#f4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#4900ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00005a"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m42.14 51.7795c-.097-.9591-.4124-1.8832-.922-2.7014s-1.2-1.5087-2.018-2.0186c-1-.53-2.09-.42-3.07-.77-1.58-.57-1.23-.44-2.26-2.13-.7447-1.2748-1.7653-2.3666-2.9869-3.1955-1.2217-.8288-2.6134-1.3737-4.0731-1.5945-.4004-.3144-.8652-.5365-1.3613-.6506-.496-.1141-1.0112-.1173-1.5087-.0094-4.67.89-14.66998 3-14.66998 9.3.00012.6064.1601 1.2021.46382 1.7271.30376.5249.74046.9605 1.26616 1.2629 1.3746.6325 2.8978.8713 4.4.69-.18.46-.35.92-.5 1.39-.62 1.92-1.35 4.26-.63 6.24 1 2.83 2.74 3.08 4.62 2.66-.77 2.51-1 5.07 1 7.09 2.75 2.78 6.54.86 9.71-1.11.3839.3673.8452.6441 1.35.81 1.0079.2878 2.0771.2817 3.0816-.0177 1.0046-.2994 1.9026-.8796 2.5884-1.6723 3.51-3.54 6.32-10.25 5.52-15.3z",
    fill: "#f1f1f1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#00005a",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m34.68 28.6405c7-8.24 18.53-13.58 28.53-13.41.2613.0122.5086.1214.6936.3064s.2942.4323.3064.6936c.23 10-5.17 21.49-13.44 28.55l-2.63 2.13-9.35 7.55c-.1895.1774-.4405.2743-.7.27-.1381.0022-.2751-.0242-.4025-.0775-.1273-.0534-.2422-.1325-.3375-.2325l-12.2-12.5c-.1835-.1948-.2857-.4523-.2857-.72 0-.2676.1022-.5252.2857-.72l6.39-7.94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.7397 25.4005c-1.2274-.009-2.4201.4075-3.3751 1.1786-.9549.7712-1.6133 1.8494-1.863 3.0512-.2496 1.2018-.0752 2.453.4936 3.5407.5687 1.0877 1.4968 1.9448 2.6263 2.4254 1.1294.4806 2.3905.5551 3.5687.2108s2.2007-1.0862 2.8936-2.0994c.6928-1.0132 1.0133-2.2352.9068-3.458-.1065-1.2229-.6333-2.3711-1.4909-3.2493-.9992-.9933-2.351-1.5506-3.76-1.55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.51 51.68-14.72-14.68"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m23.56 46.209c-3.5516 2.5284-7.7162 4.0582-12.06 4.43l.17 2c4.6841-.4037 9.1738-2.058 13-4.79zm7.51 7.88c-3.3307 3.971-5.8484 8.5579-7.41 13.5l1.92.58c1.5038-4.6585 3.8793-8.9886 7-12.76zm-4-4.24-9 9.31 1.44 1.39 9-9.31z",
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m57.21 17.8496 4.43 4.42",
    stroke: "#00005a",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m52.85 46.2598v4.71l-6.02 6.02-3.35-3.34",
    stroke: "#00005a",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m33.1797 26.6504h-4.71l-6.02 6.02 3.35 3.35",
    stroke: "#00005a",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRocket);
export default __webpack_public_path__ + "static/media/icon-rocket.fc7b1ba3eabf14c84d11ecb2e702a970.svg";
export { ForwardRef as ReactComponent };